<!-- 学员信息-activity-页面级 -->
<template>
  <div class='activity-main'>
    <ul class='task-container'>
      <li v-for='item in taskTabs'
          :key='item.id'
          :class="[item.id===activeTask ? 'active' : '']"
          @click="tabTask(item)">
        <a href='javascript:void(0)'>
          <span class='task-text'>{{item.name}}</span>
          <span class='task-num'>{{item.taskNum}}</span>
        </a>
      </li>
    </ul>
    <router-view></router-view>
  </div>
</template>

<script>
import menteeService from '@/api/undergraduate/mentee'
import { mapState } from 'vuex'
export default {
  name: '',
  components: {},
  data () {
    return {
      // 当前任务类型
      activeTask: '',
      // 学员num
      menteeNum: ''
    }
  },
  computed: mapState({
    taskTabs (state) {
      return [
        {
          id: 'appointment',
          name: 'Appointment',
          taskNum: state.activity.activityTabs.backlog || 0
        }
      ]
    }
  }),
  mounted () {
    this.activeTask = this.$route.meta.behavior
    this.menteeNum = this.$route.params.id
    // this.getTaskTabs()
  },
  methods: {
    // 获取任务面板列表
    getTaskTabs () {
      menteeService.taskNums({ menteeNum: this.menteeNum }).then(res => {
        this.taskTabs[0].taskNum = res.data.model.backlog
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
      })
    },
    // 切换面板
    tabTask (item) {
      this.activeTask = item.id
      this.$router.push({
        path: `/undergraduate/mentee/${this.menteeNum}/activity/${item.id}`
      })
    }
  }
}
</script>
<style lang='less' scoped>
.activity-main {
  padding-top: 20px;
  .task-container {
    text-align: center;
    li {
      display: inline-block;
      width: 270px;
      height: 48px;
      background: #fff;
      border-radius: 8px;
      border-radius: 8px;
      margin: 0 15px;
      a {
        display: block;
        font-size: 16px;
        color: #323c47;
        letter-spacing: 0;
        text-align: center;
        line-height: 48px;
        position: relative;
        .task-text {
          position: relative;
          &::after {
            position: absolute;
            top: -6px;
            right: -20px;
            content: "";
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 8px;
            background: #ff612f;
          }
        }
        .task-num {
          position: absolute;
          right: 10px;
          top: 0;
          font-size: 12px;
          color: #b1bcc8;
          letter-spacing: 0;
          text-align: center;
        }
      }
      &.active {
        background-image: linear-gradient(12deg, #4aa6ff 0%, #4980fd 100%);
        a {
          color: #fff;
        }
        .task-num {
          color: #fff;
        }
        .task-text::after {
          background: #fff;
        }
      }
    }
  }
}
</style>
